module.exports = __webpack_public_path__ + "static/media/profileplaceholder.7d53238a.jpg";